import React from 'react';
import { NavLink } from 'react-router-dom';
import '../../styles/Sidebar.css';
import { MdDashboard } from 'react-icons/md';
import { FaHouseChimney } from 'react-icons/fa6';
import { IoPersonSharp } from 'react-icons/io5';
import { RiBillFill } from 'react-icons/ri';
import { MdPayments } from 'react-icons/md';

interface SidebarProps {
  isOpen: boolean;
}

const menuItems = [
  { path: '/', icon: <MdDashboard size={24} />, label: 'Dashboard' },
  { path: '/properties', icon: <FaHouseChimney size={22} />, label: 'Properties' },
  { path: '/tenants', icon: <IoPersonSharp size={23} />, label: 'Tenants' },
  { path: '/bills', icon: <RiBillFill size={23} />, label: 'Bills' },
  { path: '/payments', icon: <MdPayments size={24} />, label: 'Payments' }
];

const Sidebar: React.FC<SidebarProps> = ({ isOpen }) => {
  const isMobile = window.innerWidth <= 768;

  return (
    <aside className={`sidebar ${isOpen ? 'open' : 'closed'}`}>
      <nav className="sidebar-nav">
        {menuItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) =>
              `nav-item ${isActive ? 'active' : ''}`
            }
            onClick={(e) => {
              if (isMobile) {
                e.stopPropagation();
              }
            }}
          >
            <span className="nav-icon">{item.icon}</span>
            <span className="nav-label">{item.label}</span>
          </NavLink>
        ))}
      </nav>
    </aside>
  );
};

export default Sidebar;
